<div class="accordion">
  <mat-accordion>
    <mat-expansion-panel #contactDetails [disabled]="!groupAddress.disabled || !groupPermissions.disabled" [expanded]="true">
      <mat-expansion-panel-header>Contact Details</mat-expansion-panel-header>
      <div [formGroup]="groupContact" class="accordion__container">
        <mat-form-field>
          <mat-label comFormLabelName="positionHeld">Position Held</mat-label>
          <input matInput formControlName="positionHeld" id="positionHeld" type="text" title="Position Held" />
        </mat-form-field>
        <div class="accordion__grid">
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="salutation">Salutation</mat-label>
              <mat-select formControlName="salutation" id="salutation" title="Salutation">
                <mat-option value=""></mat-option>
                @for (sal of salutations; track $index) {
                  <mat-option [value]="sal.key">{{ sal.value }}</mat-option>
                }
              </mat-select>
              <mat-error comFormMessageName="salutation">Required</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="firstName">First Name</mat-label>
              <input matInput formControlName="firstName" id="firstName" type="text" title="First Name" />
              <mat-error comFormMessageName="firstName">Required</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="lastName">Last Name</mat-label>
              <input matInput formControlName="lastName" id="lastName" type="text" title="Last Name" />
              <mat-error comFormMessageName="lastName">Required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="accordion__grid">
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="mobile">Mobile</mat-label>
              <input matInput formControlName="mobile" id="mobile" type="text" comNumbersOnly title="Mobile" />
              <mat-error comFormMessageName="mobile">Number is invalid</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="phone">Telephone</mat-label>
              <input matInput numeric formControlName="phone" id="phone" type="text" comNumbersOnly title="Phone" />
              <mat-error comFormMessageName="phone" validation="required">Required</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="email">Email</mat-label>
              <input
                matInput
                formControlName="email"
                id="email"
                type="text"
                title="Email"
                matTooltip="Your email address is your log in username. If you wish to change your email address, please contact eLicensing@Comreg.ie"
                [matTooltipDisabled]="!groupAddress.enabled"
              />
              <mat-error comFormMessageName="email" validation="required">Required</mat-error>
              <mat-error comFormMessageName="email" validation="pattern">The email format is incorrect</mat-error>
              <mat-error comFormMessageName="email" validation="emailExists">This email address is already in use</mat-error>
            </mat-form-field>
          </div>
        </div>
        <mat-checkbox formControlName="isRegulatoryContact" (change)="hasRegulatoryError = false" id="isRegulatoryContact"
          >Is Regulatory Contact</mat-checkbox
        >
        @if (providerTypeString === 'PRS') {
          <mat-checkbox (change)="hasRegulatoryError = false" formControlName="isDirector" id="isDirector">Is Director </mat-checkbox>
        }
        @if (providerTypeString === 'RADIO') {
          <mat-checkbox (change)="hasRegulatoryError = false" formControlName="isSQUContact" id="isSQUContact">Is SQU Contact </mat-checkbox>
        }
        @if (hasRegulatoryError) {
          <mat-error>{{ regulatoryErrorMessage }}</mat-error>
        }
        <div class="buttons">
          @if (groupContact.disabled) {
            <button mat-raised-button (click)="edit(groupContact)" [disabled]="!groupAddress.disabled || !groupPermissions.disabled">EDIT</button>
          }
          @if (!groupContact.disabled) {
            @if (showErrorUpdateContact) {
              <div [innerHtml]="errorMessages | arrayToList"></div>
            }
            <button mat-raised-button (click)="cancel(groupContact)">CANCEL</button>
            <button mat-raised-button [disabled]="!groupContact.valid" (click)="saveContactGroup()">UPDATE</button>
          }
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #addressInformation [disabled]="!groupContact.disabled || !groupPermissions.disabled">
      <mat-expansion-panel-header>Address Information</mat-expansion-panel-header>
      <div [formGroup]="groupAddress" class="accordion__container">
        <h3>Business Address</h3>
        <div class="accordion__grid">
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="addressLine1">Address Line 1</mat-label>
              <input matInput formControlName="addressLine1" id="addressLine1" type="text" title="Address Line 1" />
              <mat-error comFormMessageName="addressLine1">Required</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="addressLine2">Address Line 2</mat-label>
              <input matInput formControlName="addressLine2" id="addressLine2" type="text" title="Address Line 2" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="addressLine3">Address Line 3</mat-label>
              <input matInput formControlName="addressLine3" id="addressLine3" type="text" title="Address Line 3" />
            </mat-form-field>
          </div>
        </div>
        <div class="accordion__grid">
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="addressLine4">Address Line 4</mat-label>
              <input matInput formControlName="addressLine4" id="addressLine4" type="text" title="Address Line 4" />
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <mat-label comFormLabelName="postCode">Postcode</mat-label>
              <input matInput formControlName="postCode" id="postCode" type="text" title="Post Code" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label comFormLabelName="country">Country</mat-label>
              <mat-select formControlName="country" id="country" title="Country">
                <mat-option value=""></mat-option>
                @for (country of countries; track $index) {
                  <mat-option [value]="country.name">{{ country.name }}</mat-option>
                }
              </mat-select>
              <mat-error comFormMessageName="country">Required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <mat-form-field>
          <mat-label comFormLabelName="county">County</mat-label>
          <mat-select formControlName="county" id="county" title="County">
            <mat-option value=""></mat-option>
            @for (county of counties; track $index) {
              <mat-option [value]="county.key">{{ county.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="buttons">
          @if (groupAddress.disabled) {
            <button mat-raised-button (click)="edit(groupAddress)" [disabled]="!groupContact.disabled || !groupPermissions.disabled">EDIT</button>
          }
          @if (!groupAddress.disabled) {
            @if (showErrorUpdateAddress) {
              <div [innerHtml]="errorMessages | arrayToList"></div>
            }
            <button mat-raised-button (click)="cancel(groupAddress)">CANCEL</button>
            <button mat-raised-button [disabled]="!groupAddress.valid" (click)="saveAddressGroup()">UPDATE</button>
          }
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #onlineAccess [disabled]="contact.email.length === 0 || !groupContact.disabled || !groupAddress.disabled">
      <mat-expansion-panel-header> Online Access </mat-expansion-panel-header>
      <div class="accordion__container">
        <acc-contact-permissions
          #contactPermissions
          [permissionSet]="contact.accountPermissions"
          [applicationPermissions]="applicationPermissions"
          [formDisabled]="groupPermissions.disabled || !canEditPermissions"
          [contactEmail]="contact.email"
        ></acc-contact-permissions>
        <div class="buttons">
          <button mat-raised-button (click)="requestPasswordReset()" [disabled]="!canRequestPasswordReset()">Request Password Reset</button>
          <button class="button" mat-raised-button (click)="requestMfaReset()" [disabled]="!canRequestPasswordReset()">Request MFA Reset</button>
        </div>

        <div class="buttons">
          @if (groupPermissions.disabled) {
            <button mat-raised-button (click)="edit(groupPermissions)" [disabled]="!groupContact.disabled || !groupAddress.disabled">EDIT</button>
          }
          @if (!groupPermissions.disabled) {
            @if (showErrorUpdatePermissions) {
              <div [innerHtml]="errorMessages | arrayToList"></div>
            }
            <button mat-raised-button (click)="contactPermissions.reset(originalPermissionSet); cancel(groupPermissions)">CANCEL</button>
            <button
              mat-raised-button
              [disabled]="!groupPermissions.valid || contact.accountPermissions === originalPermissionSet"
              (click)="savePermissionsGroup()"
            >
              UPDATE
            </button>
          }
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="buttons" style="margin-top: 40px">
    <button mat-raised-button (click)="back()">CANCEL</button>
  </div>
</div>
